import { render, staticRenderFns } from "./PreviewFileCard.vue?vue&type=template&id=4a762eb4&scoped=true&"
import script from "./PreviewFileCard.vue?vue&type=script&lang=ts&"
export * from "./PreviewFileCard.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewFileCard.vue?vue&type=style&index=0&id=4a762eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a762eb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
